import * as fromDatatype from '../datatype-library/index';

export interface bl_ocr_scanned_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_file_item_guid: fromDatatype.GuidDataFieldInterface;
  ocr_output_json: fromDatatype.JsonDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  validation_status: fromDatatype.VarcharDatatypeInterface;
  algorithm_provider: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  scanned_doc_no: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_ocr_scanned_doc_hdr_RowClass implements bl_ocr_scanned_doc_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    app_file_item_guid: fromDatatype.GuidDataFieldInterface;
    ocr_output_json: fromDatatype.JsonDatatypeInterface;
    confidence_level: fromDatatype.NumericDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    validation_status: fromDatatype.VarcharDatatypeInterface;
    algorithm_provider: fromDatatype.VarcharDatatypeInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
    website_hdr_guid: fromDatatype.GuidDataFieldInterface;
    scanned_doc_no: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
